// GENERATED by scripts/gen-hooks.mjs. Do not edit by hand.
// 5 hooks for backend/driver.

import { useBackend } from '../useBackend'

/** POST /api/driver/claimInvite */
export function useClaimInvite<T = any>() {
  return useBackend<T>('driver/claimInvite')
}

/** POST /api/driver/disputeFine */
export function useDisputeFine<T = any>() {
  return useBackend<T>('driver/disputeFine')
}

/** POST /api/driver/getBoard */
export function useGetBoard<T = any>() {
  return useBackend<T>('driver/getBoard')
}

/** POST /api/driver/getMyFines */
export function useGetMyFines<T = any>() {
  return useBackend<T>('driver/getMyFines')
}

/** POST /api/driver/getServiceHours */
export function useGetServiceHours<T = any>() {
  return useBackend<T>('driver/getServiceHours')
}
